import React, { useEffect, useState } from "react";
import { FaCheckCircle, FaEdit, FaTrash, FaTimesCircle } from "react-icons/fa";
import "./Employes.css"; // Asegúrate de tener este archivo CSS para los estilos

const Employes = () => {
  const [messageModal, setMessageModal] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalErrorOpen, setIsModalErrorOpen] = useState(false);

  const [listEmployees, setListEmployees] = useState([]);

  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [identity, setIdentity] = useState("");
  const [role, setRole] = useState("");
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [vehiclePlate, setVehiclePlate] = useState("N/A");

  const [editingEmployee, setEditingEmployee] = useState(null);
  const [updatedData, setUpdatedData] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);

  const [emptyData, setEmptyData] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;

  const CURRENT_EMPLOYE = JSON.parse(localStorage.getItem("user"))[0]
    .identity_number;

  const typeMessages = {
    create: "¡Empleado registrado exitosamente!",
    update: "¡Datos del empleado actualizados exitosamente!",
    delete: "¡Empleado eliminado exitosamente!",
    error: "Error en el mensaje del modal",
  };

  useEffect(() => {
    getEmployees();
  }, []);

  const openModalSuccess = (type) => {
    switch (type) {
      case "create":
        setMessageModal(typeMessages.create);
        break;
      case "update":
        setMessageModal(typeMessages.update);
        break;
      case "delete":
        setMessageModal(typeMessages.delete);
        break;
      default:
        setMessageModal(typeMessages.error);
        break;
    }
    setIsModalOpen(true);
    setTimeout(() => {
      setIsModalOpen(false);
    }, 3000);
  };

  const getEmployees = () => {
    fetch(`${API_URL}/employees`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "User-Agent": "MyCustomAgent/1.0",
      },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.result) {
          setListEmployees(result.result);
        } else {
          console.log("No se pudo consultar los empleados");
        }
      });
  };

  const changeStateEmployee = (identity_number, action) => {
    if (CURRENT_EMPLOYE === identity_number) {
      setIsModalErrorOpen(true);
      setTimeout(() => {
        setIsModalErrorOpen(false);
      }, 3000);
    } else {
      fetch(`${API_URL}/update-state-employee/${identity_number}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action }),
      })
        .then((response) => response.json())
        .then(() => {
          getEmployees();
        })
        .catch((error) =>
          console.error("Error al actualizar el estado del empleado:", error)
        );
    }
  };

  const addEmployee = () => {
    const data = {
      name,
      surname,
      identity,
      role,
      user,
      password,
      vehiclePlate,
    };

    if(!name || !surname || !identity || !role || !user || !password){
      setEmptyData(true);
      setTimeout(() => {
        setEmptyData(false);
      }, 3000);
      return;
    }

    fetch(`${API_URL}/create-employee`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.result) {
          openModalSuccess("create");
          cleanFormEmployees();
          getEmployees();
        } else {
          alert("No se pudo registrar el empleado");
        }
      })
      .catch(() => {
        console.log("ERROR CACTH");
      });
  };

  const cleanFormEmployees = () => {
    setName("");
    setSurname("");
    setIdentity("");
    setRole("");
    setUser("");
    setPassword("");
    setVehiclePlate("N/A");
  };

  const handleInputChange = (e, field) => {
    const value = e.target.value;

    setUpdatedData((prev) => {
      const newData = {
        ...prev,
        [field]: value,
      };

      const allFieldsFilled = Object.values(newData).every(
        (val) => String(val || "").trim() !== ""
      );
      setIsUpdating(allFieldsFilled);

      return newData;
    });
  };

  const enableEditing = (employee) => {
    setEditingEmployee(employee.identity_number);
    setUpdatedData({
      name: employee.name,
      surname: employee.surname,
      newIdentityNumber: employee.identity_number,
      role: employee.role,
      user: employee.username,
      password: employee.password,
      vehicle_plate: employee.vehicle_plate,
    });
    setIsUpdating(true);
  };

  const updateEmployee = () => {
    if (!isUpdating) return;

    const formattedData = {
      ...updatedData,
    };

    fetch(`${API_URL}/update-employee/${editingEmployee}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formattedData),
    })
      .then((response) => response.json())
      .then(() => {
        openModalSuccess("update");
        getEmployees();
        setEditingEmployee(null);
        setIsUpdating(false);
      })
      .catch((error) =>
        console.error("Error al actualizar el empleado:", error)
      );
  };

  const deleteEmployee = (identityNumber) => {
    fetch(`${API_URL}/employee-delete/${identityNumber}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          openModalSuccess("delete");
          setListEmployees(
            listEmployees.filter(
              (employee) => employee.identity_number !== identityNumber
            )
          ); // Elimina visualmente el plan
        } else {
          alert("Error al eliminar el empleado.");
        }
      })
      .catch((error) => console.error("Error al eliminar el empleado:", error));
  };

  return (
    <div className="employees-container">
      {/* Tabla */}
      <div className="table-container">
        <h2>Consulta de Empleados</h2>
        <table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Apellido</th>
              <th>Número de identificacion</th>
              <th>Role</th>
              <th>Usuario</th>
              <th>Contraseña</th>
              <th>Placa del vehículo</th>
              <th>Acciones</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            {listEmployees.map((employee) => {
              return (
                <tr key={employee.identity_number}>
                  <td>
                    {editingEmployee === employee.identity_number ? (
                      <input
                        type="text"
                        value={updatedData.name}
                        onChange={(e) => handleInputChange(e, "name")}
                      />
                    ) : (
                      employee.name
                    )}
                  </td>
                  <td>
                    {editingEmployee === employee.identity_number ? (
                      <input
                        type="text"
                        value={updatedData.surname}
                        onChange={(e) => handleInputChange(e, "surname")}
                      />
                    ) : (
                      employee.surname
                    )}
                  </td>
                  <td>
                    {editingEmployee === employee.identity_number ? (
                      <input
                        type="text"
                        value={updatedData.newIdentityNumber}
                        onChange={(e) =>
                          handleInputChange(e, "newIdentityNumber")
                        }
                      />
                    ) : (
                      employee.identity_number
                    )}
                  </td>
                  <td>
                    {editingEmployee === employee.identity_number ? (
                      <select
                        onChange={(e) => handleInputChange(e, "role")}
                        value={updatedData.role}
                      >
                        <option value="administrador">Administrador</option>
                        <option value="apoyo administrativo">
                          Apoyo administrativo
                        </option>
                        <option value="conductor">Conductor</option>
                      </select>
                    ) : (
                      employee.role
                    )}
                  </td>
                  <td>
                    {editingEmployee === employee.identity_number ? (
                      <input
                        type="text"
                        value={updatedData.user}
                        onChange={(e) => handleInputChange(e, "user")}
                      />
                    ) : (
                      employee.username
                    )}
                  </td>
                  <td>
                    {editingEmployee === employee.identity_number ? (
                      <input
                        type="text"
                        value={updatedData.password}
                        onChange={(e) => handleInputChange(e, "password")}
                      />
                    ) : (
                      employee.password
                    )}
                  </td>
                  <td>
                    {editingEmployee === employee.identity_number ? (
                      <input
                        type="text"
                        value={updatedData.vehicle_plate}
                        onChange={(e) => handleInputChange(e, "vehicle_plate")}
                      />
                    ) : (
                      employee.vehicle_plate
                    )}
                  </td>
                  <td>
                    <FaEdit
                      className="edit-icon"
                      onClick={() => enableEditing(employee)}
                    />
                    <FaTrash
                      className="delete-icon"
                      onClick={() => deleteEmployee(employee.identity_number)}
                    />
                  </td>
                  <td>
                    <button
                      className={`button-state-employee ${
                        employee.state_employee === "ACTIVO"
                          ? "button-active"
                          : "button-inactive"
                      }`}
                      onClick={() =>
                        changeStateEmployee(
                          employee.identity_number,
                          employee.state_employee === "ACTIVO"
                            ? "inactive"
                            : "active"
                        )
                      }
                    >
                      {employee.state_employee === "ACTIVO"
                        ? "Activo"
                        : "Inactivo"}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {isUpdating && (
        <button
          className="btn-add-controle-panel"
          onClick={updateEmployee}
          disabled={!isUpdating}
        >
          Actualizar
        </button>
      )}
      {/* Formulario */}
      <div className="form-container mb-5">
        <h2>Registrar Empleado</h2>
        <div className="form-group">
          <label htmlFor="nombre">Nombre*</label>
          <input
            type="text"
            id="nombre"
            value={name}
            placeholder="Escribe el nombre"
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="apellido">Apellido*</label>
          <input
            type="text"
            id="apellido"
            value={surname}
            placeholder="Escribe el apellido"
            onChange={(e) => {
              setSurname(e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="numero_identificacion">
            Número de identificación*
          </label>
          <input
            type="text"
            id="numero_identificacion"
            value={identity}
            placeholder="Escribe el número de identificación"
            onChange={(e) => {
              setIdentity(e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="role">Rol*</label>
          <select
            id="role"
            onChange={(e) => {
              setRole(e.target.value);
            }}
            value={role}
          >
            <option value="" disabled selected>
              Selecciona un rol
            </option>
            <option value="administrador">Administrador</option>
            <option value="apoyo administrativo">Apoyo administrativo</option>
            <option value="conductor">Conductor</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="usuario">Usuario*</label>
          <input
            type="text"
            id="usuario"
            value={user}
            placeholder="Escribe el usuario"
            onChange={(e) => {
              setUser(e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="contrasena">Contraseña*</label>
          <input
            type="password"
            id="contrasena"
            value={password}
            placeholder="Escribe la contraseña"
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
        </div>

        {role === "conductor" && (
          <div className="form-group">
            <label htmlFor="vehicle_plate">Placa del vehículo</label>
            <input
              type="text"
              id="vehicle_plate"
              value={vehiclePlate === "N/A" ? "" : vehiclePlate}
              placeholder="Escribe la placa del vehículo"
              onChange={(e) => {
                setVehiclePlate(e.target.value);
              }}
            />
          </div>
        )}

        <div className="add-container">
          <button className="btn-add-employee" onClick={addEmployee}>
            Registrar
          </button>
        </div>

        {/* Modal de éxito */}
        {isModalOpen && (
          <div className="modal-success">
            <div className="modal-content">
              <FaCheckCircle size={100} color="green" className="modal-icon" />
              <h1>{messageModal}</h1>
            </div>
          </div>
        )}
        {/* Modal de error */}
        {isModalErrorOpen && (
          <div className="modal-success">
            <div className="modal-content">
              <FaTimesCircle size={100} color="red" className="modal-icon" />
              <h1>No puede desactivar su mismo usuario</h1>
            </div>
          </div>
        )}
        {emptyData && (
          <div className="modal-success">
            <div className="modal-content">
              <FaTimesCircle size={100} color="red" className="modal-icon" />
              <h1>Por favor llenar todos los campos obligatorios(*)</h1>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Employes;
